export default {
  getMenu (data) {
    for (var i = data.length - 1; i >= 0; i--) {
      if (!this.getMenuItem(data[i])) {
        data.splice(i, 1)
      }
      if (data[i] && data[i].children) {
        let children = data[i].children
        for (let a = children.length - 1; a >= 0; a--) {
          if (!this.getMenuItem(children[a])) {
            children.splice(a, 1)
          }
          if (children[a] && children[a].children) {
            let son = children[a].children
            for (let e = son.length - 1; e >= 0; e--) {
              if (!this.getMenuItem(son[e])) {
                son.splice(e, 1)
              }
            }
          }
        }
      }
    }
    // data.forEach(item => {
    //   item = this.getMenuItem(item)
    //   if (item.children) {
    //     item.children.forEach(etem => {
    //       etem = this.getMenuItem(etem)
    //       if (etem.children) {
    //         etem.children.forEach(atem => {
    //           atem = this.getMenuItem(atem)
    //         })
    //       }
    //     })
    //   }
    // })
    return data
  },
  getMenuItem (item) {
    item.leftIcon = item.icon ? ('iconfont ' + item.icon) : null
    delete (item.icon)
    if (item.external) {
      item.action = '/external?url=' + item.url
      item.action = item.action + (item.externalType ? ('&externalType=' + item.externalType) : '')
      item.text = item.displayName
    } else {
      item.action = item.url || ''
      item.text = item.displayName
    }
    if (item.visible === false) {
      return false
    }
    return true
  }
}
